<script>
import api from "../axios.js";
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

export default {
  setup() {
    const { t } = useI18n();
    const meetingsByPerson = ref({}); // lagra grupperade möten
    const loading = ref(false);

    const fetchAllMeetings = async () => {
      loading.value = true;
      try {
        const res = await api.get(
          `${apiBaseUrl}/contact-meetings/all-meetings`
        );
        meetingsByPerson.value = res.data;
      } catch (error) {
        console.error("Kunde inte hämta möten:", error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(fetchAllMeetings);

    return { t, meetingsByPerson, loading };
  },
};
</script>

<template>
  <v-container class="mt-16">
    <h2 class="text-h5 mb-4">Alla möten</h2>

    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
      class="ma-auto"
    />

    <v-expansion-panels v-else>
      <v-expansion-panel
        v-for="(meetings, email) in meetingsByPerson"
        :key="email"
      >
        <v-expansion-panel-title>
          <div>
            <strong
              >{{ meetings[0]?.firstname }} {{ meetings[0]?.lastname }}</strong
            >
            <div class="text-caption">{{ email }}</div>
          </div>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-table>
            <thead>
              <tr>
                <th>Status</th>
                <th>Tid</th>
                <th>Datum</th>
                <th>Företag</th>
                <th>Uppdaterad</th>
                <th>Skapad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="meeting in meetings" :key="meeting._id">
                <td v-if="meeting.booked === true">Bokad</td>
                <td v-else>Ansökt</td>
                <td>{{ meeting.time }}</td>
                <td>
                  {{ new Date(meeting.date).toLocaleDateString("sv-SE") }}
                </td>
                <td>{{ meeting.companyName }}</td>
                <td>{{ new Date(meeting.updatedAt).toLocaleString() }}</td>
                <td>{{ new Date(meeting.createdAt).toLocaleString() }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
